var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    stroke: "#A2A2A2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.03045C13.2525 4.78295 10.74 4.65545 8.235 4.65545C6.75 4.65545 5.265 4.73045 3.78 4.88045L2.25 5.03045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 4.27295L6.54 3.29045C6.66 2.57795 6.75 2.04545 8.0175 2.04545H9.9825C11.25 2.04545 11.3475 2.60795 11.46 3.29795L11.625 4.27295",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1373 7.40046L13.6498 14.953C13.5673 16.1305 13.4998 17.0455 11.4073 17.0455H6.5923C4.4998 17.0455 4.4323 16.1305 4.3498 14.953L3.8623 7.40046",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74707 12.9205H10.2446",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.92045H10.875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTrash);
export default __webpack_public_path__ + "static/media/bfid-trash.3a0ad838ecebea8562d19354c583bf32.svg";
export { ForwardRef as ReactComponent };